export type PriorityValue = 1 | 2 | 3 | 4 | 5;

export const priorityLabels = {
  1: 'Highest',
  2: 'High',
  3: 'Medium',
  4: 'Low',
  5: 'Minimal',
};
